module.exports = __webpack_public_path__ + "img/cooccurrence.803ea458.png";